






































































// TODO: Enable lint.
/* eslint-disable */
import { defineComponent, SetupContext } from '@vue/composition-api';
import Auth from '@aws-amplify/auth';

export default defineComponent({
  name: "NavHeader",

  setup(_, context: SetupContext) {
    async function logout() {
      Auth.signOut().then(data => {
        console.log('logout!');
        context.root.$router.push('/');
      }).catch(err => {
        console.log(err)
      });

    };

    return {
      logout
    }
  }
});
